module.exports = __webpack_public_path__ + "img/icon-facebook.5af847d7.svg";